<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Laporan Penilaian</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <select class="form-control" v-model="tab">
                                <option>Daftar OP Dengan Nilai Individu</option>
                                <option>Rincian Perhitungan Penilaian</option>
                                <option>Surat Keterangan NJOP</option>
                            </select>
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                
                <div v-if ="tab == 'Daftar OP Dengan Nilai Individu'">
                    <bhumie_laporan_penilaian_tab1></bhumie_laporan_penilaian_tab1>
                </div>
                <div v-if ="tab == 'Rincian Perhitungan Penilaian'">
                    <bhumie_laporan_penilaian_tab2></bhumie_laporan_penilaian_tab2>
                </div>
                <div v-if ="tab == 'Surat Keterangan NJOP'">
                    <bhumie_laporan_penilaian_tab3></bhumie_laporan_penilaian_tab3>
                </div>

        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>

const ADD_URL = URL_APP+'api/v1/kecamatan/';


export default {
  name: "monev_kabupaten",
  data() {
    return {
        tab: 'Daftar OP Dengan Nilai Individu',
    };
  },

// =============================================================== METHODS =========================================================================
  methods : {


  },
// =============================================================== METHODS =========================================================================

  mounted() {
    localStorage.sidemenu = 'bhumie';
  },
};
</script>
